/**
 * GameScene - 主游戏场景
 * @description 游戏的核心场景，管理物理世界、火柴人和渲染
 */

import Phaser from 'phaser';
import { PhysicsWorld, Vec2 } from '@/physics/PhysicsWorld.ts';
import { Stickman } from '@/characters/Stickman.ts';
import { FPSDisplay } from '@/ui/FPSDisplay.ts';

const GAME_WIDTH = 800;
const GAME_HEIGHT = 600;

export class GameScene extends Phaser.Scene {
  private physicsWorld!: PhysicsWorld;
  private stickman!: Stickman;
  private fpsDisplay!: FPSDisplay;

  constructor() {
    super({ key: 'GameScene' });
  }

  preload(): void {
  }

  create(): void {
    this.physicsWorld = new PhysicsWorld({
      gravity: Vec2(0, -10),
      allowSleep: true,
    });

    this.createBoundaries();
    this.createStickman();

    this.fpsDisplay = new FPSDisplay(this);
    this.fpsDisplay.enablePhysicsInfo();
    this.fpsDisplay.setPhysicsBodyCount(this.physicsWorld.getBodyCount());

    this.addInstructionText();
  }

  override update(_time: number, delta: number): void {
    const dt = delta / 1000;
    this.physicsWorld.step(dt);

    this.stickman.update();
  }

  private createBoundaries(): void {
    this.physicsWorld.createBody('ground', {
      x: GAME_WIDTH / 2,
      y: 0,
      type: 'static',
      isBoundary: true,
      boundarySize: { width: GAME_WIDTH, height: GAME_HEIGHT },
    });

    const groundGraphics = this.add.graphics();
    groundGraphics.lineStyle(2, 0x4a4a6a);
    groundGraphics.beginPath();
    groundGraphics.moveTo(0, GAME_HEIGHT);
    groundGraphics.lineTo(GAME_WIDTH, GAME_HEIGHT);
    groundGraphics.moveTo(0, 0);
    groundGraphics.lineTo(0, GAME_HEIGHT);
    groundGraphics.moveTo(GAME_WIDTH, 0);
    groundGraphics.lineTo(GAME_WIDTH, GAME_HEIGHT);
    groundGraphics.strokePath();
  }

  private createStickman(): void {
    this.stickman = new Stickman(
      this,
      this.physicsWorld,
      {
        x: GAME_WIDTH / 2,
        y: GAME_HEIGHT - 150,
        scale: 1,
      },
      GAME_HEIGHT
    );
  }

  private addInstructionText(): void {
    this.add.text(10, 10, '拖拽火柴人头部移动', {
      fontSize: '16px',
      color: '#ffffff',
      fontFamily: 'Arial',
    });

    this.add.text(10, 30, '状态: ' + this.stickman.getState(), {
      fontSize: '14px',
      color: '#888888',
      fontFamily: 'Arial',
    });
  }
}